(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-snap-finance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-snap-finance')) {
    class CartSnapFinance extends HTMLElement {
      static initialized = false;

      connectedCallback() {
        this.attempts = 0;
        this.timer = setTimeout(() => this.renderWidget(), 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      async renderWidget() {
        if (!this.isConnected) return;
        const costOfGoods = Number(this.dataset.totalCents) / 100;
        if (!Number.isFinite(costOfGoods) || costOfGoods < 250) return;

        if (typeof window.snapuk?.widgets?.productRBP !== 'function') {
          if (this.attempts++ < 40) {
            this.timer = setTimeout(() => this.renderWidget(), 250);
          }
          return;
        }

        try {
          if (!CartSnapFinance.initialized) {
            window.snapuk.init(this.dataset.clientId);
            CartSnapFinance.initialized = true;
          }
          this.hidden = false;
          await window.snapuk.widgets.productRBP({
            merchantId: Number(this.dataset.merchantId),
            costOfGoods,
            theme: 'DARK'
          });
        } catch (error) {
          this.hidden = true;
          console.warn('Snap Finance cart promotion could not load.', error);
        }
      }
    }

    customElements.define('cart-snap-finance', CartSnapFinance);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qw-zopa-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qw-zopa-card')) {
    const zopaCardStyles = `
      .dividebuy-widget.or-from-price {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-height: 88px;
        margin: 0;
        padding: 16px;
        border: 1px solid #ddeee7;
        border-radius: 10px;
        background: #eff9f5;
        color: #242424;
        font-family: var(--font-body-family, Arial, sans-serif);
        font-size: 14px;
        line-height: 1.45;
      }
      .dividebuy-widget.or-from-price .or-from-text {
        display: grid;
        grid-template-columns: 74px minmax(0, 1fr);
        column-gap: 16px;
        row-gap: 4px;
        align-items: center;
        margin: 0;
        font: inherit;
        text-align: left;
      }
      .dividebuy-widget.or-from-price .or-from-text > span {
        grid-column: 2;
        grid-row: 1;
        min-width: 0;
        margin: 0;
        font: inherit;
      }
      .dividebuy-widget.or-from-price .or-from-text > span::after {
        content: ' Zopa';
      }
      .dividebuy-widget.or-from-price .or-from-text > img {
        grid-column: 1;
        grid-row: 1 / span 2;
        align-self: center;
        justify-self: start;
        display: block;
        width: 64px;
        max-width: 100%;
        height: auto;
        margin: 0;
        object-fit: contain;
      }
      .dividebuy-widget.or-from-price .or-from-text > button,
      .dividebuy-widget.or-from-price .or-from-text > a {
        grid-column: 2;
        grid-row: 2;
        justify-self: start;
        min-width: 0;
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        color: #242424;
        font-family: inherit;
        font-size: inherit;
        font-weight: 400;
        line-height: 1.45;
        text-align: left;
        text-decoration: underline;
        text-underline-offset: 3px;
        cursor: pointer;
      }
      .dividebuy-widget.or-from-price .or-from-text > button:focus-visible,
      .dividebuy-widget.or-from-price .or-from-text > a:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
      }
      @media (max-width: 620px) {
        .dividebuy-widget.or-from-price {
          padding: 14px 12px;
          font-size: 13px;
        }
        .dividebuy-widget.or-from-price .or-from-text {
          grid-template-columns: 66px minmax(0, 1fr);
          column-gap: 14px;
        }
      }
    `;

    class QwZopaCard extends HTMLElement {
      connectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.lightObserver = new MutationObserver(() => this.findWidget());
        this.lightObserver.observe(this, { childList: true, subtree: true });
        this.findWidget();
      }

      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.lightObserver?.disconnect();
        this.shadowObserver?.disconnect();
        clearTimeout(this.shadowTimer);
        this.widget = null;
        this.widgetShadow = null;
      }

      findWidget() {
        if (!this.isConnected) return;
        const widget = this.querySelector('dividebuy-widget[widget="OrFromPriceWidget"], dividebuy-widget:not([widget])');
        if (widget === this.widget) return;
        this.shadowObserver?.disconnect();
        clearTimeout(this.shadowTimer);
        this.widget = widget;
        this.widgetShadow = null;
        this.shadowAttempts = 0;
        if (!widget) return;
        const generation = this.generation;
        if (!customElements.get('dividebuy-widget')) {
          customElements.whenDefined('dividebuy-widget').then(() => {
            if (generation === this.generation && widget === this.widget && this.isConnected) {
              this.findShadow();
            }
          });
          return;
        }
        this.findShadow();
      }

      findShadow() {
        if (!this.isConnected || !this.widget || !this.contains(this.widget)) return;
        const shadow = this.widget.shadowRoot;
        if (!shadow) {
          if (this.shadowAttempts++ < 40) {
            this.shadowTimer = setTimeout(() => this.findShadow(), 100);
          }
          return;
        }
        this.widgetShadow = shadow;
        this.shadowObserver = new MutationObserver(() => this.applyStyles());
        this.shadowObserver.observe(shadow, { childList: true });
        this.applyStyles();
      }

      applyStyles() {
        const shadow = this.widgetShadow;
        if (!this.isConnected || !shadow || !this.contains(this.widget)) return;
        let style = shadow.getElementById('qw-zopa-card-style');
        if (!style) {
          style = document.createElement('style');
          style.id = 'qw-zopa-card-style';
          style.textContent = zopaCardStyles;
        }
        if (shadow.lastChild !== style) shadow.append(style);
      }
    }

    customElements.define('qw-zopa-card', QwZopaCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snap-finance-widget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qw-product-finance')) {
    class QwProductFinance extends HTMLElement {
      static initialized = false;

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.subscriptionAttempts = 0;
        this.onVariantInput = (event) => {
          if (event.target.matches('input.product-variant-id')) {
            clearTimeout(this.timer);
            this.hidden = true;
          }
        };
        this.productInfo?.addEventListener('change', this.onVariantInput);
        this.timer = setTimeout(() => this.initialize(), 0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.unsubscribe?.();
        this.productInfo?.removeEventListener('change', this.onVariantInput);
      }

      initialize() {
        if (!this.isConnected) return;
        const pubsub = window.FoxTheme?.pubsub;
        if (!pubsub && this.subscriptionAttempts++ < 40) {
          this.timer = setTimeout(() => this.initialize(), 250);
          return;
        }
        if (pubsub) {
          this.unsubscribe = pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.sectionId) return;
            this.dataset.priceCents = data.variant?.price ?? '';
            this.queueRender();
          });
        }
        this.queueRender();
      }

      queueRender() {
        clearTimeout(this.timer);
        this.attempts = 0;
        this.hidden = true;
        this.timer = setTimeout(() => this.renderWidget(), 0);
      }

      styleWidget(container) {
        const root = container.shadowRoot;
        if (!root || root.querySelector('#qw-snap-card-style')) return;
        const style = document.createElement('style');
        style.id = 'qw-snap-card-style';
        style.textContent = `
          #snap-product-widget-container {
            display: block !important;
            width: 100%;
            min-width: 0;
          }
          #rbp-bnpl-widget {
            display: grid;
            grid-template-columns: 74px minmax(0, 1fr);
            align-items: center;
            gap: 16px;
            box-sizing: border-box;
            width: 100%;
            max-width: none;
            min-height: 88px;
            padding: 16px;
            border: 1px solid #e0eaf0;
            border-radius: 10px;
            background: #f0f5f8 !important;
            color: #242424 !important;
            font-family: var(--font-body-family, Arial, sans-serif);
            font-size: 14px;
            line-height: 1.45;
          }
          #rbp-bnpl-widget > :last-child {
            margin-left: 0;
          }
          #rbp-bnpl-widget .injected-product-widget__grid-logo {
            width: 74px;
            min-width: 0;
            padding: 0;
            background: none;
          }
          #rbp-bnpl-widget .injected-product-widget__grid-logo svg {
            display: block;
            width: 64px;
            height: auto;
          }
          #rbp-bnpl-widget .three-col-holder,
          #rbp-bnpl-widget .injected-product-widget__grid:not(.injected-product-widget__grid-logo) {
            display: block;
            min-width: 0;
            padding: 0;
            font-size: inherit;
          }
          #rbp-bnpl-widget .injected-product-widget__grid__text {
            display: block;
            height: auto;
            max-height: none;
            container-type: normal;
            font-size: inherit;
            font-weight: 400;
            line-height: 1.45;
          }
          #rbp-bnpl-widget p {
            display: flex !important;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start !important;
            gap: 3px !important;
            margin: 0 !important;
            font-size: 14px !important;
            line-height: 1.45;
          }
          #rbp-bnpl-learn-more {
            display: inline-block;
            color: inherit;
            font-weight: 400;
            text-decoration: underline;
            text-underline-offset: 3px;
          }
          @media (max-width: 620px) {
            #rbp-bnpl-widget {
              grid-template-columns: 66px minmax(0, 1fr);
              gap: 14px;
              padding: 14px 12px;
            }
            #rbp-bnpl-widget .injected-product-widget__grid-logo {
              width: 66px;
            }
            #rbp-bnpl-widget p {
              font-size: 13px !important;
            }
          }
        `;
        root.appendChild(style);
      }

      renderWidget() {
        if (!this.isConnected) return;
        const costOfGoods = Number(this.dataset.priceCents) / 100;
        if (!Number.isFinite(costOfGoods) || costOfGoods < 250) return;
        let container = this.querySelector('#snap-uk-widgets-product-rbp');
        if (!container || document.getElementById(container.id) !== container) return;
        if (this.renderedPrice === costOfGoods && container.shadowRoot?.querySelector('#rbp-bnpl-learn-more')) {
          this.styleWidget(container);
          this.hidden = false;
          return;
        }

        if (typeof window.snapuk?.widgets?.productRBP !== 'function') {
          if (this.attempts++ < 40) {
            this.timer = setTimeout(() => this.renderWidget(), 250);
          }
          return;
        }

        try {
          if (!QwProductFinance.initialized) {
            window.snapuk.init(this.dataset.clientId);
            QwProductFinance.initialized = true;
          }
          // Snap attaches a shadow root on every render, so variant updates need a fresh host.
          if (container.shadowRoot) {
            const replacement = container.cloneNode(false);
            // Late SDK responses must not bind an old quote to the replacement's shared ID.
            container.removeAttribute('id');
            container.replaceWith(replacement);
            container = replacement;
          }
          window.snapuk.widgets.productRBP({
            merchantId: Number(this.dataset.merchantId),
            costOfGoods,
            theme: 'LIGHT'
          });
          this.styleWidget(container);
          this.hidden = false;
          this.renderedPrice = costOfGoods;
        } catch (error) {
          this.hidden = true;
          console.warn('Snap Finance product promotion could not load.', error);
        }
      }
    }

    customElements.define('qw-product-finance', QwProductFinance);
  }
  } catch(e) { console.error(e); }
})();

})();
